import React from 'react';
import {COLORS} from 'constants/index';

import StoreMarker from './svgs/store.inline.svg';
import UserMarker from './svgs/user.inline.svg';
import VanMarker from './svgs/van.inline.svg';

export enum LocationType {
	van = 'van',
	store = 'store',
	user = 'user'
}

interface MarkerIconProps extends React.SVGAttributes<SVGElement> {
	color?: string;
	type: LocationType;
}

const Icons = {
	[LocationType.van]: VanMarker,
	[LocationType.store]: StoreMarker,
	[LocationType.user]: UserMarker,
};

const MarkerIcon: React.FC<MarkerIconProps> = ({
	color = COLORS.NEWDARK,
	type,
	...rest
}) => {
	const Icon = Icons[type];
	return <Icon {...rest} style={{color}} />;
};

export default MarkerIcon;
